function AuthorIcon() {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.4002 22.7488H9.40017C8.08017 22.7488 6.98017 22.6188 6.05017 22.3388C5.71017 22.2388 5.49017 21.9088 5.51017 21.5588C5.76017 18.5688 8.79017 16.2188 12.4002 16.2188C16.0102 16.2188 19.0302 18.5588 19.2902 21.5588C19.3202 21.9188 19.1002 22.2388 18.7502 22.3388C17.8202 22.6188 16.7202 22.7488 15.4002 22.7488ZM7.12017 21.0588C7.78017 21.1888 8.53017 21.2488 9.40017 21.2488H15.4002C16.2702 21.2488 17.0202 21.1888 17.6802 21.0588C17.1502 19.1388 14.9602 17.7188 12.4002 17.7188C9.84017 17.7188 7.65017 19.1388 7.12017 21.0588Z"
        fill="white"
      />
      <path
        d="M15.4 2H9.40002C4.40002 2 2.40002 4 2.40002 9V15C2.40002 18.78 3.54002 20.85 6.26003 21.62C6.48003 19.02 9.15002 16.97 12.4 16.97C15.65 16.97 18.32 19.02 18.54 21.62C21.26 20.85 22.4 18.78 22.4 15V9C22.4 4 20.4 2 15.4 2ZM12.4 14.17C10.42 14.17 8.82002 12.56 8.82002 10.58C8.82002 8.60002 10.42 7 12.4 7C14.38 7 15.98 8.60002 15.98 10.58C15.98 12.56 14.38 14.17 12.4 14.17Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3999 14.92C10.0099 14.92 8.06995 12.97 8.06995 10.58C8.06995 8.19002 10.0099 6.25 12.3999 6.25C14.7899 6.25 16.7299 8.19002 16.7299 10.58C16.7299 12.97 14.7899 14.92 12.3999 14.92ZM12.3999 7.75C10.8399 7.75 9.56995 9.02002 9.56995 10.58C9.56995 12.15 10.8399 13.42 12.3999 13.42C13.9599 13.42 15.2299 12.15 15.2299 10.58C15.2299 9.02002 13.9599 7.75 12.3999 7.75Z"
        fill="white"
      />
    </svg>
  );
}

export default AuthorIcon;
